import ErrorPage from 'pages/errors/error-page'
import { useTranslation } from 'react-i18next'

const NotFound = () => {
  const { t } = useTranslation()
  return <ErrorPage title={t('error.http.not-found.title')}>{t('error.http.not-found.message')}</ErrorPage>
}

export default NotFound
